import graphQLRequest from "../../graphQlRequest.js";
import updateCartShippingInfoMutation from "./updateCartShippingInfo";

/**
 * Fetch a Add items cart by  ids
 *
 * @param {String} Id's - The input to update
 * @returns {Object} Cart - the fetched Add items to cart
 */

export default async function fetchUpdateCartShippingInfo(cart_id,shipping_info) {
  if (!cart_id) return { cart: {} };
  const resp = await graphQLRequest(updateCartShippingInfoMutation, {
    input: {
        cart_id,
        shipping_info
    },
  });

  return resp && resp;
}
